import { shippingAccountValidate } from '../../application/dtos/shipping_account_validate';

export class shippingAccountEntity {
    constructor({ id, name }){
        this.id = id;
        this.name = name;
    }

    isValid() {
        return shippingAccountValidate(this);
    }
}